<template>
    <v-card class="mx-auto" min-width="500">

        <v-card-title class="text-h6 font-weight-regular justify-space-between">
        <span>Νεο παραστατικό</span>
        </v-card-title>

        <v-dialog v-model="selectAccountDialog" max-width="400">
            <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
                <v-card-title class="text-wrap">
                    <p>{{account.name}}</p>
                </v-card-title>
              
                <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
              
                <v-card-text>
                    <v-container>
                        <v-row>
                            <div>{{account.city}} {{account.zipcode}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.address}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.telephone}}</div>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateAccount(selectAccountDialogShownFor, account); closeSelectAcountDialog();">ΕΠΙΛΟΓΗ</v-btn>
                </v-card-actions>
            </v-card>
     
        </v-dialog>
        <!-- ΒΑΣΙΚΑ ΣΤΟΙΧΕΙΑ -->

        <v-window v-model="step">
            <v-window-item :value="0">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Βασικά στοιχεία</h3>
                    
                    <v-select 
                        v-bind:items="documentTypes" 
                        v-model="selectedDocumentType"
                        return-object
                        
                        item-text="description" 
                        label="Είδος παραστατικού"
                        v-bind:error-messages="allerrors.document_type_id">
                    </v-select>

                    <v-select 
                        v-show="selectedDocumentType.series.length > 1 || (selectedSeries.name && selectedSeries.name.length > 0)"
                        v-bind:items="selectedDocumentType.series"
                        v-model="selectedSeries"
                        return-object
                        item-text="name"
                        item-value="id" 
                        label="Σειρά παραστατικού"
                        v-bind:error-messages="allerrors.document_series">
                    </v-select>

                    <v-text-field 
                        v-if="selectedSeries.autonumbered == false"
                        v-model.number="document_number" 
                        label="Αριθμός παραστατικού"
                        v-bind:error-messages="allerrors.document_series"
                        v-bind:disabled="selectedSeries.autonumbered">
                    </v-text-field>

                    <v-menu
                        v-model="menu2"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="document_issue_date"
                                label="Ημερομηνία έκδοσης"
                                append-icon="mdi-calendar"
                                readonly
                                v-bind="attrs"
                                v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker
                            v-model="document_issue_date"
                            @input="menu2 = false">
                        </v-date-picker>
                    </v-menu>

                    <v-select
                        v-bind:items="vehicles"
                        v-model="selectedVehicle"
                        return-object

                        item-text="plates"
                        label="Όχημα"
                        append-icon="mdi-truck"
                        v-bind:error-messages="allerrors.vehicle_id">
                    </v-select>
                </v-card-text>
            </v-window-item>






            <!-- ΑΠΟΣΤΟΛΕΑΣ -->

            <v-window-item :value="1">
                <v-card-text>
                    <v-row class="mb-2 ml-2 mr-2">
                        <h3 class="text-h6 font-weight-light ">Στοιχεία <strong>αποστολέα</strong></h3>
                        <v-spacer></v-spacer>
                        <v-btn text color="warning" @click="sender = {}" >ΚΑΘΑΡΙΣΜΑ</v-btn>
                    </v-row>
                    <v-text-field 
                        v-model="sender.name" 
                        append-icon="mdi-account-search"
                        @click:append="searchAccountByName('sender')"
                        v-bind:disabled="senderNotEditable"
                        v-bind:error-messages="allerrors.sender.name">
                            <template #label>
                                <span class="red--text"><strong>* </strong></span>Επωνυμία
                            </template>
                    </v-text-field>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="sender.tax_registration_number"
                                label="ΑΦΜ"
                                append-icon="mdi-account-search"
                                @click:append="searchAccountByTaxRegistrationNumber('sender')"
                                v-bind:disabled="senderNotEditable"
                                v-bind:loading="disabledTaxRegistrationNumberFields.sender"
                                v-bind:error-messages="allerrors.sender.tax_registration_number">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-model="sender.tax_registration_office_id"
                                v-bind:items="taxOffices" 
                                item-text="name" 
                                item-value="id" 
                                label="ΔΟΥ"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.tax_registration_office_id">
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field 
                                v-model="sender.jobtitle" 
                                label="Επάγγελμα"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.jobtitle">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-model="sender.country_id"
                                v-bind:items="countries" 
                                item-text="name_gr" 
                                item-value="id"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.country_id">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Χώρα
                                    </template>
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-combobox
                                v-model="sender.city"
                                v-bind:items="filteredSenderCities"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.city">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Πόλη
                                    </template>
                            </v-combobox>
                        </v-col>
                        
                    </v-row>                    

                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field 
                                v-model="sender.address" 
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.address">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Διεύθυνση
                                    </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field 
                                v-model="sender.zipcode" 
                                label="ΤΚ"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.zipcode">
                            </v-text-field>
                        </v-col>
                    </v-row>            

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="sender.telephone" 
                                label="Αριθμός τηλεφώνου"
                                append-icon="mdi-account-search"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.telephone">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="sender.mobile" 
                                label="Αριθμός κινητού"
                                append-icon="mdi-account-search"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.mobile">
                            </v-text-field>
                        </v-col>
                    </v-row>                    


                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="sender.fax" 
                                label="Αριθμός Φαξ"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.fax">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="sender.email" 
                                label="E-Mail"
                                v-bind:disabled="senderNotEditable"
                                v-bind:error-messages="allerrors.sender.email">
                            </v-text-field>
                        </v-col>
                    </v-row>



                </v-card-text>
            </v-window-item>


            <!-- ΠΑΡΑΛΗΠΤΗΣ } -->

            <v-window-item :value="2">
                <v-card-text>
                    <v-row class="mb-2 ml-2 mr-2">
                        <h3 class="text-h6 font-weight-light ">Στοιχεία <strong>παραλήπτη</strong></h3>
                        <v-spacer></v-spacer>
                        <v-btn text color="warning" @click="recipient = {}" >ΚΑΘΑΡΙΣΜΑ</v-btn>
                    </v-row>
        
                    <v-text-field 
                        v-model="recipient.name" 
                        append-icon="mdi-account-search"
                        @click:append="searchAccountByName('recipient')"
                        v-bind:disabled="recipientNotEditable"
                        v-bind:error-messages="allerrors.recipient.name">
                            <template #label>
                                <span class="red--text"><strong>* </strong></span>Επωνυμία
                            </template>
                    </v-text-field>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="recipient.tax_registration_number"
                                label="ΑΦΜ"
                                append-icon="mdi-account-search"
                                @click:append="searchAccountByTaxRegistrationNumber('recipient')"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:loading="disabledTaxRegistrationNumberFields.recipient"
                                v-bind:error-messages="allerrors.recipient.tax_registration_number">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-model="recipient.tax_registration_office_id"
                                v-bind:items="taxOffices" 
                                item-text="name" 
                                item-value="id" 
                                label="ΔΟΥ"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.tax_registration_office_id">
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field 
                                v-model="recipient.jobtitle" 
                                label="Επάγγελμα"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.jobtitle">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-model="recipient.country_id"
                                v-bind:items="countries" 
                                item-text="name_gr" 
                                item-value="id"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.country_id">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Χώρα
                                    </template>
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-combobox
                                v-model="recipient.city"
                                v-bind:items="filteredRecipientCities"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.city">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Πόλη
                                    </template>
                            </v-combobox>
                        </v-col>
                        
                    </v-row>                    

                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field 
                                v-model="recipient.address" 
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.address">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Διεύθυνση
                                    </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field 
                                v-model="recipient.zipcode" 
                                label="ΤΚ"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.zipcode">
                            </v-text-field>
                        </v-col>
                    </v-row>            

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="recipient.telephone" 
                                label="Αριθμός τηλεφώνου"
                                append-icon="mdi-account-search"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.telephone">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="recipient.mobile" 
                                label="Αριθμός κινητού"
                                append-icon="mdi-account-search"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.mobile">
                            </v-text-field>
                        </v-col>
                    </v-row>                    


                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="recipient.fax" 
                                label="Αριθμός Φαξ"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.fax">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="recipient.email" 
                                label="E-Mail"
                                v-bind:disabled="recipientNotEditable"
                                v-bind:error-messages="allerrors.recipient.email">
                            </v-text-field>
                        </v-col>
                    </v-row>



                </v-card-text>
            </v-window-item>




            <!-- ΕΝΤΟΛΕΑΣ -->

            <v-window-item :value="3">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-2">Στοιχεία <strong>εντολέα</strong></h3>        
                    
                    <v-item-group>
                        <v-btn color="primary" @click="consignor = sender; consignorIsSender = true">ΑΝΤΙΓΡΑΦΗ ΑΠΟΣΤΟΛΕΑ</v-btn>
                        <v-btn color="primary" @click="consignor = recipient; consignorIsRecipient = true" >ΑΝΤΙΓΡΑΦΗ ΠΑΡΑΛΗΠΤΗ</v-btn>
                        <v-btn color="warning" @click="consignor = {}; consignorIsSender = false; consignorIsRecipient = false" >ΚΑΘΑΡΙΣΜΑ</v-btn>
                    </v-item-group>

                    <v-text-field 
                        v-model="consignor.name" 
                        append-icon="mdi-account-search"
                        v-bind:disabled="consignorNotEditable"
                        @click:append="searchAccountByName('consignor')"
                        v-bind:error-messages="allerrors.consignor.name">
                            <template #label>
                                <span class="red--text"><strong>* </strong></span>Επωνυμία
                            </template>
                    </v-text-field>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="consignor.tax_registration_number"
                                label="ΑΦΜ"
                                append-icon="mdi-account-search"
                                v-bind:disabled="consignorNotEditable"
                                @click:append="searchAccountByTaxRegistrationNumber('consignor')"
                                v-bind:loading="disabledTaxRegistrationNumberFields.consignor"
                                v-bind:error-messages="allerrors.consignor.tax_registration_number">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-model="consignor.tax_registration_office_id"
                                v-bind:items="taxOffices" 
                                item-text="name" 
                                item-value="id" 
                                label="ΔΟΥ"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.tax_registration_office_id">
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12">
                            <v-text-field 
                                v-model="consignor.jobtitle" 
                                label="Επάγγελμα"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.jobtitle">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-model="consignor.country_id"
                                v-bind:items="countries" 
                                label="Χώρα" 
                                item-text="name_gr" 
                                item-value="id"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.country_id">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Χώρα
                                    </template>
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-combobox
                                v-model="consignor.city"
                                v-bind:items="filteredConsignorCities"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.city">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Πόλη
                                    </template>
                            </v-combobox>
                        </v-col>
                        
                    </v-row>                    

                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field 
                                v-model="consignor.address" 
                                label="Διεύθυνση"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.address">
                                    <template #label>
                                        <span class="red--text"><strong>* </strong></span>Διεύθυνση
                                    </template>
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="4">
                            <v-text-field 
                                v-model="consignor.zipcode" 
                                label="ΤΚ"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.zipcode">
                            </v-text-field>
                        </v-col>
                    </v-row>            

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="consignor.telephone" 
                                label="Αριθμός τηλεφώνου"
                                append-icon="mdi-account-search"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.telephone">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="consignor.mobile" 
                                label="Αριθμός κινητού"
                                append-icon="mdi-account-search"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.mobile">
                            </v-text-field>
                        </v-col>
                    </v-row>                    


                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="consignor.fax" 
                                label="Αριθμός Φαξ"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.fax">
                            </v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="consignor.email" 
                                label="E-Mail"
                                v-bind:disabled="consignorNotEditable"
                                v-bind:error-messages="allerrors.consignor.email">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-window-item>





            <!-- ΕΜΠΟΡΕΥΜΑΤΑ } -->

            <v-window-item :value="4">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-2">Εμπορεύματα</h3>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="pickup_location"
                                label="ΦΟΡΤΩΣΗ">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="delivery_location"
                                label="ΠΑΡΑΔΟΣΗ">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-data-table
                        :headers="itemsHeaders"
                        :items="items"
                        sort-by="calories"
                        class="elevation-1"
                        disable-pagination
                        disable-filtering
                        hide-default-footer>
                        
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Εμπορεύματα</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>

                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <!-- 
                                            <v-btn color="primary" dark class="mb-2" v-on:click="addPackage">+1 ΔΕΜΑ</v-btn>
                                        -->
                                        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">ΠΡΟΣΘΗΚΗ</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row>
                                                    <v-col cols="12" md="8" sm="6">
                                                        <v-text-field
                                                            v-model="editedItem.invoice"
                                                            label="Τιμολόγιο-ΔΑΠ">
                                                        </v-text-field>

                                                        <v-select
                                                            label="Συσκευασία"
                                                            v-model="editedItem.package_id"
                                                            v-bind:items="packages"
                                                            item-text="name"
                                                            item-value="id">
                                                        </v-select>

                                                        <!--
                                                        <v-btn-toggle v-model="editedItem.package_id">
                                                            <v-btn 
                                                                v-bind:key="packageType.id" 
                                                                v-for="packageType in packages"
                                                                v-bind:value="packageType.id" 
                                                                color="primary"
                                                                text
                                                                class="ma-2">
                                                                {{ packageType.name }}
                                                            </v-btn>
                                                        </v-btn-toggle>
                                                        -->
                                                        
                                                        <v-text-field
                                                            label="Ποσότητα"
                                                            v-model.number="editedItem.package_quantity"
                                                            track-color="grey"
                                                            always-dirty
                                                            min="0"
                                                            max="100"
                                                            thumb-label="always"
                                                            type="number">

                                                            <template v-slot:prepend>
                                                                <v-icon @click="editedItem.package_quantity--">mdi-minus </v-icon>
                                                            </template>

                                                            <template v-slot:append>
                                                                <v-icon @click="editedItem.package_quantity++">mdi-plus</v-icon>
                                                            </template>
                                                        </v-text-field>

                                                        <v-text-field 
                                                            v-model="editedItem.contents"
                                                            label="Περιεχόμενα">
                                                        </v-text-field>

                                                        <v-text-field
                                                            v-model.number="editedItem.weight"
                                                            label="Βάρος"
                                                            type="number">
                                                        </v-text-field>

                                                        <v-text-field
                                                            v-model.number="editedItem.volume"
                                                            label="Όγκος"
                                                            type="number">
                                                        </v-text-field>

                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                                            <v-btn color="blue darken-1" text @click="save" v-bind:disabled="lineEntryIncomplete">ΕΝΤΑΞΕΙ</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>

                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.name }}";</v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                                            <v-btn color="error darken-1" text @click="deleteItemConfirm">ΕΝΤΑΞΕΙ</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
                            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
                        </template>
                    </v-data-table>

                    <v-text-field
                        v-model="comments"
                        label="Σχόλια">
                    </v-text-field>
                </v-card-text>
            </v-window-item>

            <v-window-item :value="5">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Χρεώσεις {{totalChargedAmount}}</h3>

                    <v-select 
                        v-bind:items="filteredPaymentTypes" 
                        v-model="selectedPaymentType"
                        return-object
                        
                        item-text="description" 
                        label="Τρόπος πληρωμής"
                        v-bind:error-messages="allerrors.payment_type_id">
                    </v-select>


                    <template v-for="charge in charges">
                        <vuetify-money
                            v-bind:key="charge.id"
                            v-bind:label="charge.description"
                            v-model="charge.amount"
                            v-bind:options="moneyFieldOptions">
                        </vuetify-money>
                    </template>                    

                    <vuetify-money
                        v-model="third_party_charges"
                        label="Χρεώσεις τρίτων"
                        v-bind:options="moneyFieldOptions">
                    </vuetify-money>

                </v-card-text>

            </v-window-item>

            <v-window-item :value="6">
                <v-card-text>
                    <h3 class="text-h6 font-weight-light mb-4">Συνοψη παραστατικού</h3>
                    
                    <v-text-field
                        disabled 
                        v-model="selectedDocumentType.description" 
                        label="Παραστατικό">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="document_issue_date" 
                        label="Ημερομηνία">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="consignor.name" 
                        label="Εντολέας">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="sender.name" 
                        label="Αποστολέας">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="recipient.name" 
                        label="Παραλήπτης">
                    </v-text-field>

                    <v-text-field
                        disabled 
                        v-model="recipient.address" 
                        label="Διεύθυνση">
                    </v-text-field>


                    <v-text-field
                        disabled 
                        v-model="totalChargedAmountSummary" 
                        label="Καθαρές χρεώσεις">
                    </v-text-field>

                    <div class="text-center">
                        <v-btn 
                            color="success" 
                            @click="saveDocument" 
                            v-bind:loading="saveDocumentButtonDisabled">
                            ΑΠΟΘΗΚΕΥΣΗ
                        </v-btn>
                    </div>
                </v-card-text>

            </v-window-item>


        </v-window>

        <v-card-actions>
            <v-btn
                v-bind:disabled="step <= 0"
                text
                v-on:click="step--"
                color="primary">
                ΠΙΣΩ
            </v-btn>
            <v-spacer></v-spacer>
            <v-item-group
                v-model="step"
                class="text-center"
                mandatory>
                <v-item
                        v-for="n in totalSteps"
                        v-bind:key="`btn-${n}`"
                        v-slot="{ active, toggle }">
                    <v-btn
                        v-bind:input-value="active"
                        icon
                        dense
                        x-small
                        disabled
                        @click="toggle">
                        <v-icon color="blue">mdi-record</v-icon>
                    </v-btn>
                </v-item>
            </v-item-group>

            <v-spacer></v-spacer>
            <v-btn
                v-bind:disabled="(step >= totalSteps - 1) || (stepCompleted == false)"
                color="primary"
                depressed
                @click="scroll2top(); step++;">
                ΕΠΟΜΕΝΟ
            </v-btn>
        </v-card-actions>


    </v-card>

</template>

<script>
import goTo from 'vuetify/lib/services/goto'
import currency from "currency.js"

export default {
    data () {
        return {
            moneyFieldOptions: {
                locale: "el-GR",
                prefix: "€",
                suffix: "",
                length: 8,
                precision: 2
            },

            step: 0,
            totalSteps: 7,
            menu2: false,
            saveDocumentButtonDisabled: false,
            
            consignorIsSender: false,
            consignorIsRecipient: false,

            allerrors : {
                sender: {},
                recipient: {},
                consignor: {}
             },

            documentTypes: [],
            documentSeries: [],
            taxOffices: [],
            countries: [],
            packages: [],
            paymentTypes: [],
            charges: [],
            vehicles: [],




            selectedDocumentType: {
                series: [],
                charges: []
            },

            selectedSeries: {},
            selectedVehicle: {},

            filteredDocumentSeries: [],

            document_number: '',
            document_issue_date: '',

            sender: {},
            recipient: {},
            consignor: {},
            

            selectedPaymentType: {},

            third_party_charges: 0,
            comments: null,
            
            items: [],
            dialog: false,
            dialogDelete: false,
            selectAccountDialog: false,
            selectAccountDialogEntries: [],
            selectAccountDialogShownFor: '',

            pickup_location: '',
            delivery_location: '',

            itemsHeaders: [
                {
                    text: 'Τιμ-ΔΑ',
                    align: 'start',
                    sortable: false,
                    value: 'invoice',
                },
                {
                    text: 'Ποσότητα',
                    align: 'start',
                    sortable: false,
                    value: 'package_quantity',
                },
                {
                    text: 'Συσκευασία',
                    align: 'start',
                    sortable: false,
                    value: 'package.name',
                },
                {
                    text: 'Περιεχόμενα',
                    align: 'start',
                    sortable: false,
                    value: 'contents',
                },

                {
                    text: 'Βάρος',
                    align: 'start',
                    sortable: false,
                    value: 'weight',
                },
                {
                    text: 'Όγκος',
                    align: 'start',
                    sortable: false,
                    value: 'volume',
                },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            editedIndex: -1,
            editedItem: {
                invoice: '',
                package_id: '',
                package_quantity: 0,
                contents: '',
                weight: 0,
                volume: 0,
            },
            defaultItem: {
                invoice: '',
                package_id: '',
                package_quantity: 0,
                contents: '',
                weight: 0,
                volume: 0,
            },

            disabledTaxRegistrationNumberFields: {
                sender: false,
                recipient: false,
                consignor: false
            }

        }
    },

    created() {
        this.initialize()
    },

    watch: {
        selectedDocumentType: function (val) {
            this.document_number = ''
            this.selectedSeries = {}

            this.charges = this.selectedDocumentType.charges.map(x => { 
                return {
                    id: x.id,
                    description: x.description,
                    amount: x.default_net_amount ?? 0.0
                } 
            });

         
            if (this.selectedDocumentType.series.length == 1)
                this.selectedSeries = this.selectedDocumentType.series[0]


        },

        'sender.city': function (val) {
            this.pickup_location = val
        },

        'recipient.city': function (val) {
            this.delivery_location = val
        }


    },

    computed: {


        filteredConsignorCities() { return [] },
        filteredSenderCities() { return [] },
        filteredRecipientCities() { return [] },
        formTitle () { return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία' },

        lineEntryIncomplete() {
            let isLineOk = (this.editedItem.package_quantity ?? 0 > 0) && (this.editedItem.package_id ?? 0 > 0);
            return isLineOk == false;
        },
        
        selectedDocumentTypeDescription () { 
            if (this.document_type_id && this.documentTypes.length > 0)
                return this.documentTypes.find(x => x.id == this.document_type_id).description

            return ''
        },

        totalPackageCount() {
            const reducer = (a, b) => (a + b)

            return this.items.map(x => x.package_quantity).reduce(reducer, 0)
        },

        totalChargedAmount() {
            const reducer = (a, b) => (currency(a).add(b))

            return this.charges.map(x => parseFloat(x.amount)).reduce(reducer, 0.0).value
        },

        filteredPaymentTypes() {
            if (this.selectedDocumentType && (this.selectedDocumentType.id ?? 0) > 0) {

                if (this.selectedDocumentType.updates_ledger == false)
                    return this.paymentTypes.filter(x => x.flag_credit == true)
                
                return this.paymentTypes
            }
                
        },
        
        totalChargedAmountSummary() {
            let chargedAmount = this.totalChargedAmount

            if ((this.selectedPaymentType.id ?? 0) > 0 && chargedAmount)
                return `(${this.selectedPaymentType.description}) ${chargedAmount}`
        },

        stepCompleted() {
            switch (this.step) {
                case 0:
                    if (!this.selectedDocumentType.id)
                        return false
                    
                    if (!this.selectedVehicle.id)
                        return false
                    
                    //if (!this.selectedSeries.id)
                    //    return false
                    
                    if (!this.document_issue_date)
                        return false

                    if (this.selectedSeries.autonumbered == false && (this.document_number.toString().length > 0 == false))
                        return false
                    
                    break

                case 1:
                    if ((this.sender.name ?? '').length > 1 == false)
                        return false

                    if ((this.sender.country_id ?? 0) > 0 == false)
                        return false
                    
                    if ((this.sender.city ?? '').length > 1 == false)
                        return false

                    if ((this.sender.address ?? '').length > 1 == false)
                        return false
                    
                    break

                case 2:
                    if ((this.recipient.name ?? '').length > 1 == false)
                        return false

                    if ((this.recipient.country_id ?? 0) > 0 == false)
                        return false
                    
                    if ((this.recipient.city ?? '').length > 1 == false)
                        return false

                    if ((this.recipient.address ?? '').length > 1 == false)
                        return false
                    
                    break

                case 3:
                    if ((this.consignor.name ?? '').length > 1 == false)
                        return false

                    if ((this.consignor.country_id ?? 0) > 0 == false)
                        return false
                    
                    if ((this.consignor.city ?? '').length > 1 == false)
                        return false

                    if ((this.consignor.address ?? '').length > 1 == false)
                        return false
                    
                    break

                case 4:
                    if (this.items.length > 0 == false)
                        return false

                    if (this.totalPackageCount > 0 == false)
                        return false
                    
                    break

                case 5:
                    if ((this.selectedPaymentType.id?? 0) > 0 == false)
                        return false

                    if (this.totalChargedAmount > 0 == false)
                        return false

                    break

                default:
                    return true
            }
        },

        consignorNotEditable() {
            return (this.consignorIsSender || this.consignorIsRecipient || ((this.consignor.id ?? 0) > 0))
        },

        senderNotEditable() {
            return (this.sender.id ?? 0) > 0
        },

        recipientNotEditable() {
            return (this.recipient.id ?? 0) > 0
        }
            
    },


    methods: {
        mixmatch (item) {
            item.package = this.packages.find(pkg => pkg.id == item.package_id)

            return item;
        },

        scroll2top() {
            goTo(0)
        },

        initialize() {
            // this.document_issue_date = new Date().toISOString().slice(0, 10)

            const dateAthens = new Intl.DateTimeFormat('en-CA', {
                timeZone: 'Europe/Athens',
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).format(new Date());

            this.document_issue_date = dateAthens;


            axios.all([
                axios.get('/api/document-types/transportation'),
                axios.get('/api/tax-offices'),
                axios.get('/api/countries'),
                axios.get('/api/packages'),
                axios.get('/api/tax-authority/payment-types'),
                axios.get('/api/vehicles')
            ]).then(
                axios.spread(
                (
                    documentTypesResponse, 
                    taxOfficesResponse, 
                    countriesResponse, 
                    packagesResponse,
                    paymentTypesResponse,
                    vehiclesResponse
                ) => {
                    this.documentTypes = documentTypesResponse.data.sort((a, b) => a.description.localeCompare(b.description))
                    this.taxOffices = taxOfficesResponse.data.sort((a, b) => a.name.localeCompare(b.name))
                    this.countries = countriesResponse.data
                    this.packages = packagesResponse.data
                    this.paymentTypes = paymentTypesResponse.data
                    this.vehicles = vehiclesResponse.data
            })).catch(error => { console.log(error) })
            .finally( () => { 
                //this.prePopulate();
                // this.sender.name = 'ΠΛΑΤΑΝ'
                // this.searchAccountByName('sender')
            })
        },

        editItem (item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        deleteItem (item) {
            this.editedIndex = this.items.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialogDelete = true
        },

        deleteItemConfirm () {
            this.items.splice(this.editedIndex, 1); 
            this.closeDelete();
        },

        close () {
            this.dialog = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        closeDelete () {
            this.dialogDelete = false
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            })
        },

        save () {
            if (this.editedIndex > -1) {
                Object.assign(this.items[this.editedIndex], this.mixmatch(this.editedItem)); 
            } else {
                this.items.push(this.mixmatch(this.editedItem));
            }
            this.close();
        },

        saveDocument() {
            console.log(this.saveDocumentButtonDisabled)
            this.saveDocumentButtonDisabled = true;
            console.log(this.saveDocumentButtonDisabled)
            let requestBody = {
                document_type_id: this.selectedDocumentType.id,
                document_series_id: this.selectedSeries.id,
                document_issue_date: this.document_issue_date,
                document_number: this.document_number,
                vehicle_id: this.selectedVehicle.id,

                sender: this.sender,
                recipient: this.recipient,
                consignor: this.consignor,
                pickup_location: this.pickup_location.length > 0 ? this.pickup_location : this.sender.city,
                delivery_location: this.delivery_location.length > 0 ? this.delivery_location : this.recipient.city,
                
                line_items: this.items,
                
                payment_type_id: this.selectedPaymentType.id,
                charges: this.charges.map(x => { return { charge_type_id : x.id, amount: x.amount, gross_value: this.selectedDocumentType.suggest_gross_values }}),
                
                third_party_charges: this.third_party_charges,
                comments: this.comments
            }

            axios.post('/api/documents/transportation', requestBody)
            .then(_ => { 
                this.$router.push({ name: 'transportationdocuments' })
            })
            .catch(error => { 
                console.log(error)
                if (error.response && error.response.data) {
                    if (error.response.data.errors) {
                        const errs = { sender: {}, recipient: {}, consignor: {} }
                        for (const [key, val] of Object.entries(error.response.data.errors)) {
                            const parts = key.split('.')
                            if (parts.length === 2) {
                                if (!errs[parts[0]]) errs[parts[0]] = {}
                                errs[parts[0]][parts[1]] = val
                            } else {
                                errs[key] = val
                            }
                        }
                        this.allerrors = errs
                        const messages = Object.values(error.response.data.errors).flat().join('<br>')
                        this.$swal({ icon: 'error', title: 'Σφάλμα', html: messages })
                    } else if (error.response.data.message) {
                        this.$swal({ icon: 'error', title: 'Σφάλμα', text: error.response.data.message })
                    }
                }
            })
            .finally( () => { this.saveDocumentButtonDisabled = false })
        },

        async searchAccountByTaxRegistrationNumber(accountPropertyName) {
            if (this.disabledTaxRegistrationNumberFields[accountPropertyName] == true)
                return

            this.disabledTaxRegistrationNumberFields[accountPropertyName] = true

            let needle = this[accountPropertyName].tax_registration_number
            let response = await axios.get(`/api/accounts/search/tax-registration-number/${needle}`)

            this.disabledTaxRegistrationNumberFields[accountPropertyName] = false
            
            if (response.data.length == 1) {
                let account = response.data[0]

                this.updateAccount(accountPropertyName, account)
                
                if (this.taxOffices.filter(taxOffice => taxOffice.code == account.tax_office.code).length > 0 == false) {
                    //this.taxOffices.push(account.tax_οffice)
                    axios.get('/api/tax-offices')
                    .then(response => this.taxOffices = response.data)
                }
            } else if (response.data.length > 1) {
                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
            
        },

        async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_registration_office_id: data.tax_registration_office_id,
                jobtitle: data.jobtitle
            }
        }
            //.catch(error => { console.log(error) })
    }
}
</script>

<style scoped>

</style>
